export default __webpack_public_path__ + "static/media/fairImage.fcf3a70c.jpg";